import { render, staticRenderFns } from "./FormActing.vue?vue&type=template&id=586d8f2d&scoped=true&"
import script from "./FormActing.vue?vue&type=script&lang=js&"
export * from "./FormActing.vue?vue&type=script&lang=js&"
import style0 from "./FormActing.vue?vue&type=style&index=0&id=586d8f2d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "586d8f2d",
  null
  
)

export default component.exports